(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('StrutturaSearch', StrutturaSearch);

    StrutturaSearch.$inject = ['$resource'];

    function StrutturaSearch($resource) {
        var resourceUrl =  'api/_search/strutturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
